<div class="sidenav-content">
  <div class="bcontainer2">
    <div class="main-content">
    <div class="spacer2"></div>

    <div class="containter">
      <div class="mfhd">
        <i
          class="fa fa-angle-left"
          aria-hidden="true"
          style="padding-right: 5px"
        ></i
        >Usage
        <div
          class="page-description"
          style="
            color: #9c9b9b;
            font-size: 14px;
            margin-top: 8px;
            margin-bottom: 16px;
          "
        >
          Track overall and per-user memory usage, view consumption stats, and
          manage your subscription easily.
        </div>
      </div>

      <div class="spacer2"></div>

      <div class="card-container">
        <div class="card">
          <div class="cdesc">Plan</div>
          <div class="chd text-caps">{{ usage?.tier }}</div>
          <div class="cdiv"></div>
          <div class="cdesc">Monthly Limit</div>
          <div class="chd">{{ usage?.monthlyLimit }}</div>
        </div>

        <div class="card">
          <div class="cdesc">Memory Used</div>
          <div class="chd">{{ usage?.tokenConsumed }}</div>
          <div class="cdiv"></div>
          <div class="cdesc">Memory Remaining</div>
          <div class="chd">{{ usage?.tokensRemaining }}</div>
        </div>

        <div class="card">
          <div class="cdesc">Recipes Saved</div>
          <div class="chd">{{ usage?.recipesUsed ?? 0 }}</div>
          <div class="cdiv"></div>
          <div class="cdesc">Counts Toward Limit</div>
          <div class="chd">No</div>
        </div>

        <!-- <div class="card">
          <div class="cdesc">Tokens Rollover</div>
          <div class="chd">{{ usage?.tokensRollover }}</div>
          <div class="cdiv"></div>
          <div class="cdesc">Overage Cost</div>
          <div class="chd">{{ usage?.overageCost }}</div>
        </div> -->

        <div class="card">
          <div class="cdesc">Usage Percentage</div>
          <div class="chd">{{ usage?.usagePercentage }}</div>
          <div class="cdiv"></div>
          <div class="cdesc">Start Period</div>
          <div class="chd">
            {{ spdate | tzfmt : "MMM dd, yyyy" : appService.TimeZoneName }}
          </div>
        </div>
      </div>

      <div class="spacer2"></div>

      <!-- User Breakdown Table - Fixed condition -->
      <div *ngIf="usage?.userBreakdown?.length > 0">
        <h3>User Breakdown</h3>
        <table
          mat-table
          [dataSource]="usage?.userBreakdown"
          class="mat-elevation-z8"
          multiTemplateDataRows
        >
          <ng-container matColumnDef="userKey">
            <th mat-header-cell *matHeaderCellDef>User Key</th>
            <td mat-cell *matCellDef="let element">
              {{ element.userKey }}
            </td>
          </ng-container>

          <ng-container matColumnDef="tokensused">
            <th mat-header-cell *matHeaderCellDef>Token Consumed</th>
            <td mat-cell *matCellDef="let element">
              {{ element.tokens_used }}
            </td>
          </ng-container>

          <ng-container matColumnDef="recipesused">
            <th mat-header-cell *matHeaderCellDef>Recipes Saved</th>
            <td mat-cell *matCellDef="let element">
              {{ element.recipes_used ?? 0 }}
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: displayedColumns"
            class="main-row"
          ></tr>

          <!-- No data message -->
          <!-- <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" [attr.colspan]="displayedColumns.length" style="text-align: center; height: 50vh;">
            {{ loading ? 'Loading...' : 'No user breakdown data available' }}
          </td>
        </tr> -->
        </table>
      </div>

      <!-- No data message -->
      <div
        *ngIf="usage?.userBreakdown?.length === 0"
        class="no-data"
        style="font-size: 15px"
      >
        No user breakdown data available
      </div>
    </div>

    </div>
  </div>
</div>
